import { useRandomColor } from "@/hooks/use-random-color";
import { Flex, Stack, Text } from "@mantine/core";

import clsx from "clsx";

interface CoursePerformanceBarProps {
  value: number;
  label: string;
  ratio: number;
  skeleton?: boolean;
}

export function CoursePerformanceBar({
  value,
  label,
  ratio,
  skeleton,
}: CoursePerformanceBarProps) {
  const color = useRandomColor();

  return (
    <Stack gap={9} justify="end" flex={1}>
      <Text
        ta="center"
        className={clsx("text-primary-text-body prose-sm/medium", {
          skeleton,
        })}
        mx="md"
      >
        {label}
      </Text>
      <Flex
        bg={`${color}.3`}
        c={`${color}.10`}
        className={clsx("rounded-t-2xl prose-base/medium", { skeleton })}
        p={12}
        ta="center"
        align="end"
        justify="center"
        style={{
          flexBasis: ratio,
        }}
      >
        {value}
      </Flex>
    </Stack>
  );
}
